import React, {useRef} from 'react'
import { domain, domain_need } from '../../../../Urls/Services/Api_urls';
import Swal from 'sweetalert2';
import "./sigCanvas.css";

const Savesignature = (props) => {
    const token = window.sessionStorage.getItem("token");
    const sigCanvas = useRef(props.sigCanvas);
    const tableMeta = props.tableMeta;
    const handleSubmit = () => {
    if (
        sigCanvas.current.getTrimmedCanvas().toDataURL("image/png") !== null &&
        sigCanvas.current.getTrimmedCanvas().toDataURL("image/png").length >= 200
    ) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            signature: sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"),
            is_actived: "Firmado",
        });

        var requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch(
            domain + "/portal/" + tableMeta.rowData[0] + "/update_signature/",
            requestOptions
        )
            .then((response) => response.text())
            .then((result) =>
                Swal.fire({
                    title: "Contrato firmado exitosamente",
                    html: "Se ha firmado el contrato satisfactoriamente, se recargara la pagina en <b></b> milisegundos",
                    icon: "success",
                    showCancelButton: false,
                    timer: 5000,
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    didOpen: () => {
                        const b = Swal.getHtmlContainer().querySelector("b");
                        setInterval(() => {
                            b.textContent = Swal.getTimerLeft();
                        }, 100);
                    },
                    confirmButtonColor: "#3085d6",
                    showConfirmButton: true,
                    confirmButtonText: "Ver contrato",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.open(domain_need + "/Contract/" + tableMeta.rowData[0]);
                    }
                    window.location.reload();
                })
            )
            .catch((error) => console.log("error", error));
    }
    }

    return (
        <>
            <button
            
                className="btn btn7"
                onClick={() => {
                    handleSubmit();
                }}
            >
                <b>Firmar</b>
            </button>

        </>

    )
};

export default Savesignature;